


// import React, { useState } from 'react'; // Import React and useState hook
// import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation between routes
// import { auth, googleProvider, signInWithPopup, firestore } from './firebase'; // Import Firebase auth, Google provider, sign-in function, and Firestore
// import './Login.css'; // Import custom CSS styles for the login component
// import ReCaptcha from './ReCaptcha'; // Import ReCaptcha component for bot protection
// import SignIn from './PhoneAuth'; // Import PhoneAuth component for phone number login
// import NewUserSignIn from './NewUserSignIn'; // Import NewUserSignIn component for new user registration
// import { collection, doc, setDoc, getDoc } from 'firebase/firestore'; // Import Firestore functions for managing document data
// import { IconButton, Button } from '@mui/material'; // Import MUI components for styling
// import GoogleIcon from '@mui/icons-material/Google'; // Import Google icon from Material UI Icons

// const Home = () => {
//   const navigate = useNavigate();
//   const [isVerified, setIsVerified] = useState(false);
//   const [showPhoneInput, setShowPhoneInput] = useState(false);
//   const [showNewUserSignIn, setShowNewUserSignIn] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');

//   // Function to navigate to the Admin page
//   const handleAdminLogin = () => {
//     navigate('/Admin');
//   };

//   // Function to handle ReCaptcha verification
//   const handleReCaptchaVerify = (verified) => {
//     setIsVerified(verified);
//     if (verified) {
//       showErrorMessage('');
//     } else {
//       showErrorMessage('ReCaptcha verification failed. Please try again.');
//     }
//   };

//   // Function to show error messages and hide them after a delay
//   const showErrorMessage = (message) => {
//     setErrorMessage(message);
//     setTimeout(() => {
//       setErrorMessage('');
//     }, 2000); // Hide error message after 2 seconds
//   };

//   // Function to store user profile in Firestore
//   const storeUserProfile = async (user) => {
//     const userProfileRef = doc(collection(firestore, 'UserProfileMaster'), user.uid);
//     const userProfileSnap = await getDoc(userProfileRef);

//     if (!userProfileSnap.exists()) {
//       await setDoc(userProfileRef, {
//         uid: user.uid,
//         displayName: user.displayName || '',
//         email: user.email || '',
//         phoneNumber: user.phoneNumber || '',
//         photoURL: user.photoURL || '',
//         createdAt: new Date(),
//       });
//       console.log('User profile stored in UserProfileMaster');
//     } else {
//       console.log('User profile already exists in UserProfileMaster');
//     }
//   };

//   // Function to handle sign-in with a specified provider (Google)
//   const SignInWithProvider = (provider) => {
//     if (!isVerified) {
//       showErrorMessage('Please complete the reCAPTCHA verification.');
//       return;  // Prevent login if reCAPTCHA is not verified
//     }
//     signInWithPopup(auth, provider)
//       .then(async (result) => {
//         const user = result.user;
//         await storeUserProfile(user);
//         navigate('/Home');
//       })
//       .catch((error) => {
//         console.error("Sign-in error:", error);
//         showErrorMessage(`Failed to sign in with ${provider.providerId.split('.')[0]}.`);
//       });
//   };

//   // Function to show phone login input
//   const handlePhoneLogin = () => {
//     setShowPhoneInput(true);
//   };

//   // Function to show new user registration form
//   const handleNewUserSignIn = () => {
//     setShowNewUserSignIn(true);
//   };

//   const handleEmailLogin = () => {
//     // Add the email login logic here, or navigate to an email login page
//     showErrorMessage('Email login is not implemented yet.');
//   };

//   // If the new user sign-in form is being shown, render it instead of the login form
//   if (showNewUserSignIn) {
//     return <NewUserSignIn />;
//   }

//   // Main component rendering
//   return (
//     <div className="home-container">
//       {errorMessage && <div className="error-message">{errorMessage}</div>}
      
//       <h1>Welcome</h1>
//       <div className="login-container">
//         <div className="login-box">
//           <div className="login-buttons">
//             <Button 
//               variant="contained" 
//               startIcon={<GoogleIcon />} 
//               onClick={() => SignInWithProvider(googleProvider)}
//               style={{ margin: '8px 0', backgroundColor: '#4285F4', color: '#fff' }}
//             >
//               Login with Google
//             </Button>
//           </div>
//           <div className="recaptcha-container">
//             <ReCaptcha onVerify={handleReCaptchaVerify} />
//           </div>
//           {showPhoneInput && <SignIn onSignInSuccess={storeUserProfile} />}
//           <div className="register-option">
//             <p>Don't have an account?</p>
//             <button onClick={handleNewUserSignIn} className="register-btn">Register / Sign Up</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;



import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, googleProvider, signInWithPopup, firestore } from './firebase';
import './Login.css';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { Button } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import ReCAPTCHA from 'react-google-recaptcha';

const Home = () => {
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const navigate = useNavigate();

  // Function to check if the user's profile exists by email
  const checkUserProfileByEmail = async (email) => {
    const userProfileRef = collection(firestore, 'UserProfileMaster');
    const q = query(userProfileRef, where('email', '==', email));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty; // true if user profile exists, false otherwise
  };

  // Function to handle sign-in with Google
  const SignInWithProvider = async (provider) => {
    try {
      if (!captchaVerified) {
        alert("Please verify CAPTCHA first.");
        return;
      }

      // Sign in with Google using Firebase Authentication
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const email = user.email;
      const tenantId = 'defaultTenant';  // You can set the tenantId according to your system
      const userRole = 'user';           // Default role can be 'user', modify as necessary

      // Send user data to your API to generate JWT
      const response = await fetch('https://user-management-api-v1.onrender.com/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, tenantId, userRole }),
      });

      const data = await response.json();

      if (response.ok) {
        // Store the generated JWT in session storage
        const jwtToken = data.token;
        console.log("Received JWT Token:", jwtToken);
        sessionStorage.setItem('jwtToken', jwtToken); // Store the JWT for future use
      
        // Check if the user's email exists in the UserProfileMaster collection
        const userExists = await checkUserProfileByEmail(email);
      
        if (userExists) {
          console.log("User profile exists. Proceeding with login.");
          navigate('/Home');
        } else {
          navigate('/register'); // Redirect to registration if profile doesn't exist
        }
      } else {
        console.error("Error generating JWT:", data.message);
        alert("Authentication failed. Please try again.");
      }
      

    } catch (error) {
      console.error("Sign-in error:", error);
    }
  };

  // Function to handle reCAPTCHA verification
  const onCaptchaChange = (value) => {
    setCaptchaVerified(!!value); // Set CAPTCHA verification status
  };

  return (
    <div className="home-container">
      <h1>Welcome</h1>
      <div className="login-container">
        <div className="login-box">
          <div className="login-buttons">
            <Button 
              variant="contained" 
              startIcon={<GoogleIcon />} 
              onClick={() => SignInWithProvider(googleProvider)}
              style={{ margin: '8px 0', backgroundColor: '#4285F4', color: '#fff' }}
            >
              Login with Google
            </Button>
          </div>

          {/* CAPTCHA Component */}
          <div className="captcha-container">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              onChange={onCaptchaChange}
            />
          </div>

          <div className="register-option">
            <p>Don't have an account?</p>
            <button onClick={() => navigate('/register')} className="register-btn">Register / Sign Up</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;